// Shared media helpers.

// Convert a YouTube watch URL or Loom share URL into the corresponding
// embed URL. Returns null for anything else so the caller can fall back
// to a direct <video> tag or skip rendering entirely.
export const getEmbedUrl = (url) => {
  if (!url) return null;
  let embedUrl = null;
  if (url.includes('youtube.com/watch?v=')) {
    const videoId = new URL(url).searchParams.get('v');
    embedUrl = `https://www.youtube.com/embed/${videoId}`;
  } else if (url.includes('loom.com/share/')) {
    const videoId = url.substring(url.lastIndexOf('/') + 1);
    embedUrl = `https://www.loom.com/embed/${videoId}`;
  }
  return embedUrl;
};
